import Tool from "../Tool";

export default class PolygonTool extends Tool {
  constructor(editor) {
    super(editor);
  }

  render(layer) {
    let shape = this.createPolygon();

    this.editor.frameManager.setShapeToLayer(layer.id, shape);

    this.applyLayerStyle(
      shape,
      layer.options[layer.state.value],
      layer.visible
    );
    shape.plot([...layer.points]);
  }

  createPolygon() {
    const shape = this.editor.svg.polygon();
    return shape;
  }

  getBBox(layer) {
    if (!layer.shape) {
      return false;
    }
    return layer.shape.bbox();
  }

  handleZoom(layer) {
    this.applyLayerStyle(
      layer.shape,
      layer.options[layer.state.value],
      layer.visible
    );
  }

  handleClick(event) {}

  handleMouseMove(event) {}

  applyLayerStyle(shape, style, visible) {
    const { stroke, fill } = style;

    shape.fill({ color: fill.color, opacity: fill.opacity }).stroke({
      width: stroke.width / this.editor.getters.getZoom(),
      color: stroke.color,
      opacity: stroke.opacity,
    });
    shape.attr("stroke-dasharray", stroke.style === "dashed" ? 5 : "none");
    if (visible & this.getCurrentBreakpoint()) {
      shape.attr("display", "block");
    } else {
      shape.attr("display", "none");
    }
  }

  getCenterCoords(layer) {
    let pointer = {};
    const bbox = layer.shape.bbox();
    pointer.x = bbox.x + bbox.width / 2;
    pointer.y = bbox.y + bbox.height / 2;

    return pointer;
  }
}
